import {
  CancelBookingCancellerEnum,
  InvoiceStatus
} from '@link/supplier/services/const';

export default {
  layouts: {
    sidebar: {
      notifications: '通知',
      contractsList: '販売権限設定状況',
      activitiesManagement: '商品管理',
      activities: '商品一覧',
      allotmentSettings: '在庫設定',
      backendSettings: 'Backend在庫設定',
      backendCalendar: 'カレンダー',
      settings: '設定',
      changePassword: 'パスワード変更',
      suppliers: '催行会社管理',
      suppliersDetail: '会社情報',
      suppliersAccount: 'アカウント管理',
      info: '基本情報',
      detail: '詳細情報',
      agent: '価格グループ設定',
      i18n: '多言語設定',
      planInfo: 'プラン - {{title}}',
      bookingInfoSettings: '予約情報設定',
      price: 'ユニット/料金設定',
      addPlan: 'プラン追加',
      editMemo: 'メモ編集',
      editLog: '編集履歴',
      adminSetting: 'Admin設定',
      adminPlanInfo: 'プラン - {{title}} 設定',
      adminActivity: '商品設定',
      allotmentSetting: '営業日・通常在庫設定',
      allotmentSegmentId: '開始時間ID追加',
      allotmentException: '例外開始時間設定',
      allotmentCalendar: 'カレンダー編集',
      allotmentOtaGroup: '旅行代理店在庫グループ設定',
      allotmentBackend: 'Backend設定',
      booking: '予約管理',
      unprocessedList: '未処理リスト',
      finance: '支払管理',
      bulkOrder: '一括注文',
      dataExport: 'データ出力'
    }
  },
  views: {
    dataExport: {
      period: '期間',
      dataExport: 'データ出力',
      bookingData: '予約データ',
      dateMode: '日付モード',
      byBookingDate: '予約日による',
      byParticipationDate: '参加日による',
      outputMode: '出力形式',
      byBookings: '予約による',
      byTravelers: '旅行者による',
      status: 'ステータス',
      download: 'ファイルダウンロード',
      today: '今日',
      yesterday: '昨日',
      oneWeek: '一週間',
      thisMonth: '今月',
      lastMonth: '前月'
    },
    bulkBookingDetail: {
      history: '操作内容',
      action: '操作',
      operator: '操作者',
      date: '日付',
      message: 'メッセージ',
      notifyConfirmed: '送金承認',
      paymentDate: '送金日',
      paymentConfirmed: '送金を承認しました',
      infoSentToSupplier: '情報は旅行代理店へ送信されました'
    },
    dashboard: {
      title: 'ダッシュボード'
    },
    activities: {
      templateSource: '商品',
      heading: '商品一覧',
      status: 'ステータス',
      title: '商品名',
      inputSupplierTitle: '商品名を入力してください',
      addActivity: '商品登録',
      edit: '編集',
      confirmed: '商品設定完了、公開可能です。',
      name: '商品名',
      list: '商品一覧',
      addNewActivity: '新規商品登録',
      add: '登録',
      selectSupplier: '催行会社を選択してください',
      copyTitle: '商品コピー',
      selectSupplierLabel: 'サプライヤー選択',
      copy: 'コピー',
      copyModalTitle: 'Copy-{{text}}',
      export: 'ダウンロード',
      isBulkOrder: '一括注文'
    },
    backendSettings: {
      newTitle: '新規Backend在庫設定',
      management: '在庫登録',
      poolId: '管理ID',
      supplierId: '催行会社名',
      name: '管理名',
      confirm: '確定',
      state: '状態',
      status: 'ステータス',
      lastExecution: '前回更新',
      nextExecution: '次回更新',
      jobStatus: {
        success: 'Success',
        failed: 'Failed'
      }
    },
    activity: {
      mergePlanError: '商品に既存のプランがある場合は、インポートを禁止する',
      importError: 'ファイルの形式または内容に問題があります。',
      import: 'インポート',
      title: '商品',
      log: {
        logHistory: '商品編集履歴',
        priceHistory: '価格グループ編集履歴',
        chooseLog: '履歴選択',
        chooseItemLabel: 'プラン {{index}} 編集履歴',
        html: 'HTMLログ',
        by: 'by'
      },
      memo: {
        title: '編集用メモ',
        tips: '編集用メモは商品編集時の記録用のもので、旅行代理店または直販サイト上では表示されません。',
        successUpdated: 'メモを保存しました'
      },
      tag: {
        title: '編集用タグ',
        tips: '編集用タグは商品編集時の記録用のもので、旅行代理店または直販サイト上では表示されません。'
      },
      paymentCollector: '集金先',
      productDescription: '商品説明',
      priceSetting: '支払通貨設定',
      autoPublic: '自動公開設定',
      autoPublicGroup: '対象グループ選択',
      imageSetting: '画像設定',
      participantNotice: '参加前後の注意事項（含まれるものなど）',
      agentGroupName: '価格グループ名',
      agentSaved: '旅行代理店を保存しました',
      agentSetting: '価格グループ設定',
      addAgentGroup: '価格グループを追加',
      agentTips:
        '※価格グループは旅行代理店ごとの価格設定と連携しているため、1つの旅行代理店を複数のグループに追加することはできません。',
      comment: 'コメント',
      publishedApplied: '公開申請しました。',
      rejectApplied: '差し戻しました。',
      approved: '承認しました。',
      published: '公開しました。',
      publish: '公開',
      publishToNeoOnly: 'NEOのみ公開',
      publishToNextOnly: 'NEXT（現行システム）のみ公開',
      reject: '差し戻し',
      approve: '公開承認',
      submit: '公開申請',
      save: '保存',
      preview: 'プレビュー',
      productPreview: '商品プレビュー',
      voucherPreview: 'バウチャープレビュー',
      applyForPublish: '商品公開申請',
      productConfirmationMessage:
        'ご登録した商品の内容とプランをご確認の上、商品公開してください。',
      confirmPermission: '権限がありません',
      confirmReject: '承認差し戻し',
      confirmApprovalOfProduct: '商品公開承認',
      productContentConfirmed: '商品の内容を確認しました。',
      confirmForPublishingProducts: '商品公開確認',
      productPublishedConfirmed: '商品の公開を承認しました。',
      productSaved: '商品を保存しました',
      languageSetting: '多言語設定',
      languageSelection: '言語選択',
      productTitle: '商品名（バウチャー表示名）',
      origin: '出発地',
      destination: '目的地',
      checkinPoints: '集合場所',
      checkoutPoints: '解散場所',
      pickupLocation: 'ピックアップ場所',
      dropoffLocations: 'お送り場所',
      cancellationPolicy: 'キャンセルポリシー',
      faqSetting: 'FAQ設定',
      chosenLanguage: '掲載言語',
      timeZone: '国・地域（タイムゾーン）',
      category: 'カテゴリ',
      useQrCode: 'QRコード利用',
      qrcodeType: 'QRコードタイプ',
      qrcodeDisplayLocations: 'QRコード表示箇所',
      voucherSetting: 'バウチャー設定',
      voucherVersion: 'バウチャーバージョン',
      appointmentSetting: '予約設定',
      appointmentNotification: '予約通知',
      useEticketItems: 'E-TICKET利用項目',
      qrcodeTemplate: 'QRコードテンプレート',
      qrcodeHeader: 'QRコードヘッダー',
      qrcodeFooter: 'QRコードフッター',
      qrcodeGenerator: 'QRコードジェネレーター',
      redemptionUrlTemplate: '引換URLテンプレート',
      adminSettingSaved: 'Admin設定を保存しました',
      allotmentSettingSaved: 'プラン設定を保存しました',
      planSelection: 'プラン選択',
      planId: 'プランID',
      systemCharge: 'システム料金',
      productInfo: '商品情報',
      supplierId: '催行会社ID',
      supplierName: '催行会社名',
      name: '商品名',
      editMemo: '編集用メモ',
      editTag: '編集用タグ',
      publishActivityConfirm: 'こちらの商品を公開しますか？',
      publishActivitySuccess:
        '※商品公開すると、価格設定に追加した旅行代理店アカウントにて商品情報が閲覧可能となります。',
      inPublish: '公開中',
      isActivityPublished: '商品を公開しました',
      isActivityPublishedFailed: '商品の公開に失敗しました',
      contactUs: 'お手数をおかけしますが、担当者へご連絡ください。',
      leaveCurrentPage: 'このページを離れる',
      continueEditing: '編集を続ける',
      salesStatus: '商品表示',
      hideFromSearch: '商品一覧表示',
      salesStatusNotes:
        '※商品の表示状態を変更した場合、再度公開が必要となりますのでご注意ください。',
      hideFromSearchNotes:
        '※一覧表示をオフにした場合、検索結果および商品一覧画面には表示されませんのでご注意ください。',
      qrCodeTips:
        '※『人数分のQRコード発行』または『モギリ利用』の設定は弊社の担当へご連絡ください。'
    },
    allotmentSettings: {
      heading: '営業日・通常在庫設定',
      title: '在庫設定',
      new: '在庫登録',
      poolId: '管理ID',
      supplierId: '催行会社名',
      name: '管理用在庫名',
      inputAllotmentName: '管理用在庫名を入力してください',
      leaveCurrentPage: 'このページを離れる',
      continueEditing: '編集を続ける',
      edit: {
        name: '在庫',
        createTitle: '新規在庫登録',
        copyTitle: '在庫コピー'
      },
      form: {
        id: '在庫ID',
        name: '管理用在庫名',
        freesale: 'フリーセール',
        copyCalendarEdits: 'カレンダー編集コピー',
        add: '通常在庫追加'
      },
      exception: {
        name: '特定日開始時間設定',
        default: '通常在庫',
        allowedDefault: '利用可能',
        disallowedDefault: '利用不可',
        defaultApplicable: '(通常在庫設定適用: {{applicable}})',
        applicable: '適用する',
        notApplicable: '適用しない'
      },
      segmentId: {
        name: '開始時間ID',
        addPrompt: '開始時間ID追加',
        refTime: '参考時間',
        startTimeIdRequired: '開始時間IDを入力してください',
        startTimeRequired: '開始時間を入力してください'
      },
      otaGroup: {
        name: '旅行代理店在庫グループ設定',
        groupName: '旅行代理店在庫グループ名',
        addPrompt: '旅行代理店在庫設定追加',
        addOta: '旅行代理店追加',
        deleteOta: '旅行代理店削除'
      },
      backendBundle: {
        backendOption: 'Backend',
        bundleOption: 'Bundle',
        backendId: 'Backend在庫ID',
        bundleChildAllotmentPoolId: '関連子商品在庫ID',
        parentStartTimeId: '開始時間在庫ID',
        refTime: '参考時間',
        childStartTimeId: '子商品開始時間在庫ID',
        addPrompt: '関連子商品ID追加',
        label: 'Backend選択',
        bundleStartTimeSetting: '開始時間ID設定',
        segmentTime: '開始時間ID',
        childSegmentTimeId: '子商品開始時間ID',
        backendAllotment: 'Backend在庫設定',
        bundleAddPrompt: 'Bundle用在庫設定追加',
        bundleGroupHeaderText: '関連子商品ID'
      }
    },
    agentGroup: {
      addAgent: '旅行代理店追加',
      deleteAgent: '旅行代理店削除'
    },
    plan: {
      title: 'プラン',
      saveConfirm: 'プランを保存しました',
      name: 'プラン名',
      planPublish: 'プラン掲載表示',
      bookingRule: '予約設定',
      voucherExpiration: 'バウチャー有効期限',
      expirationVisibilitySetting: 'バウチャー有効期限を非表示にする',
      visibilitySetting: {
        hideFromVoucher: 'バウチャー上で非表示',
        hideFromActivityDetails: 'ウェブページ上で非表示（商品内容）',
        hideFromBookingDetails: 'ウェブページ上で非表示（予約詳細）'
      },
      checkinPoint: '集合場所',
      checkoutPoint: '解散場所',
      pickupLocation: 'ピックアップ場所',
      dropoffLocation: 'お送り場所',
      unitSetting: 'ユニット設定',
      priceSetting: '料金設定',
      bookingAgentRequiredInfo: '代表者情報-予約ごと（必須）',
      bookingAgentRecommendedInfo: '代表者情報-予約ごと（任意）',
      bookingOtherRequiredInfo: 'その他情報-予約ごと（必須）',
      bookingOtherRecommendedInfo: 'その他情報-予約ごと（任意）',
      participantRequiredInfo: '利用者情報-参加者ごと（必須）',
      participantRecommendedInfo: '利用者情報-参加者ごと（任意）',
      customBookingInfo: 'カスタマイズ予約情報',
      settingUnable: '終了日を開始日の前に設定することはできません',
      description: 'プラン説明',
      imageSetting: '画像設定',
      availablePeriod: '公開期間',
      reservationRestrict: '予約数量制限',
      pieces: '枚',
      min: '最小',
      max: '最大',
      tilde: '〜',
      checklistLabel: '参加前・参加時の注意事項（含まれるものなど）',
      startTime: '開始時間',
      setSchedule: 'スケジュール設定',
      editConfirm: '編集の確認',
      leave: 'このページを離れる',
      continueEditing: '編集を続ける',
      code: {
        id: 'プランID',
        coupon: 'Bundle子商品のバウチャーを非表示にする',
        backendId: '在庫設定ID',
        backendIdLabel: '在庫設定を選択してください',
        goToSetting: '未設定の場合は<0>こちら</0>から設定してください',
        backend: 'Backend情報',
        backendLabel: '連携するBackendを選択してください',
        productCode: 'Product Code',
        productCodeLabel: 'Product Codeを記入してください',
        unit: 'Unit設定',
        unitType: 'ユニット種類',
        unitRange: '単位範囲',
        unitCode: 'Unit Code',
        startTimeTitle: '開始時間設定',
        startTime: '開始時間',
        startTimeCode: 'Start time Code',
        codeLabel: 'Codeを記入してください',
        linkToAllotment: '在庫設定にリンク'
      },
      planPublishNotes:
        '※プランの表示状態を変更した場合、商品を再公開する必要がありますのでご注意ください。',
      duplicatePlan: 'プランを複製する',
      ruleDeadlineDayNotes:
        '※予約期限に「0」を入力すると、【当日】から起算し、当日を含みます。',
      voucherExpirationNotes:
        '※有効期限に「1」を入力すると、【当日】から起算し、当日を含みます。「0」を入力した場合は即時失効となりますので、ご注意ください。'
    },
    bookingTodos: {
      title: '未処理リスト',
      count: '件',
      within24Hours: '24時間以内',
      within5Days: '5日以内',
      within7Days: '7日以内',
      over7Days: '7日以上',
      purchasedDate: '支払申請日',
      productPlan: '商品/プラン',
      bookerName: '予約者名',
      deadline: '締切',
      timeRemaining: '締切まで残り',
      timeRemainingFormat: '{{hours}}時間{{minutes}}分{{seconds}}秒'
    },
    bookingDetail: {
      requestPanelTitle: '確認待ち注文の回答',
      applicationDate: '申請日時',
      deadlineLabel: '締切',
      accept: '承認',
      deny: '受付不可',
      rejects: '拒否',
      denyReasonPlaceholder: '拒否する理由を入力してください',
      actionTitle: 'あなたはこの予約リクエストを{{action}}しました。'
    },
    bookingCancel: {
      form: 'キャンセルフォーム',
      canceller: 'キャンセル者',
      reason: '理由',
      comment: 'コメント',
      cancellationFee: 'キャンセル料',
      time: '現在の日付・時刻',
      money: '販売価格',
      refundAllSystemFee: 'システム料金を全額返金',
      discount: 'X',
      percentFormula: '% =',
      pleaseSetCancelFee: 'キャンセル料を設定してください'
    },
    financeHistory: {
      title: '支払履歴',
      dataAggregation: 'データ集計',
      aggregationUnit: '集計単位',
      targetPeriod: '対象期間',
      monthly: '月次',
      weekly: '週単位',
      confirmed: '確定済み',
      canceledRefund: 'キャンセル返金',
      differenceAdjusted: '差額調整済み',
      totalAmount: '合計金額',
      cancellationFee: '(内キャンセル料)',
      serviceFee: 'システム料金',
      totalPaymentAmount: '支払金額合計',
      price: '({{currency}})',
      salesPrice: '販売価格',
      wholesalePrice: '卸価格',
      commission: 'コミッション',
      transactionSearch: '支払検索',
      applicationDate: '申込日',
      participationDate: '参加日',
      transactionStatus: '予約ステータス',
      keyword: 'キーワード',
      activity: '商品',
      plan: 'プラン',
      supplier: '催行会社',
      reservationNumber: '予約番号',
      currency: '通貨'
    },
    financeTransactions: {
      title: '精算書',
      transactionStatus: '精算状況',
      keyword: '支払通知書ID',
      difference: '差額調整',
      dueDate: '支払通知書発行日',
      invoiceNumber: '支払通知書ID',
      date: '対象期間',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '通貨',
      amount: '支払金額合計',
      adjustedAmount: '調整金額',
      finalAmount: '最終合計金額',
      showjust: '表示',
      change: '入金完了',
      invoice: 'ダウンロード',
      jaInvoice: '支払通知書(日本語)',
      jaInvoiceDetails: '明細書(日本語)',
      enInvoice: '支払通知書(英語)',
      enInvoiceDetails: '明細書(英語)',
      attachment: '添付ファイル',
      changeTitle: '入金完了ですか？',
      changeMessage: '取引状態は「入金完了」に変更します'
    }
  },
  common: {
    activityId: 'テンプレート ID',
    search: '検索',
    leaveCurrentPageConfirm: `{{name}}はまだ編集中です`,
    successCreatedMsg: '{{name}}追加に成功しました',
    errorCreatedMsg: '{{name}}追加に失敗しました',
    successDeletedMsg: '{{name}}削除に成功しました',
    errorDeletedMsg: '{{name}}削除に失敗しました',
    successUpdatedMsg: '{{name}}更新に成功しました',
    errorUpdatedMsg: '{{name}}更新に失敗しました',
    sharedAllotment: '共有在庫',
    colon: ':'
  },
  const: {
    cancelBookingCanceller: {
      [CancelBookingCancellerEnum.Supplier]: '催行会社',
      [CancelBookingCancellerEnum.SupplierForTraveler]: 'お客様'
    },
    templateStatus: {
      DRAFT: '下書き',
      REVIEWING: '公開申請中',
      APPROVED: '公開確認済',
      PUBLISHED: '公開済み（NEXTのみ）',
      NEO_PUBLISHED: '公開済み（NEOのみ）',
      BOTH_PUBLISHED: '公開済み（NEO・NEXT）'
    },
    jobState: {
      ENABLED: '成功',
      PAUSED: '停止',
      DISABLED: '無効',
      UPDATE_FAILED: '更新失敗',
      ERROR: 'エラー'
    },
    universalType: {
      TRUE: '各プラン共通',
      FALSE: '各プラン異なる'
    },
    voucherType: {
      NONE: '不要',
      COLLECTIVE: '予約ごとのQRコード',
      INDIVIDUAL: '1人1つのQRコード'
    },
    qrcodeType: {
      QRCODE: 'QRコード',
      TEXT: 'TEXT',
      URL: 'URL',
      BARCODE_128: 'BARCODE_128',
      BARCODE_93: 'BARCODE_93',
      BARCODE_39: 'BARCODE_39',
      BARCODE_25: 'BARCODE_25'
    },
    qrcodeDisplayLocation: {
      QR_CODE_DISPLAY_LOCATION_VOUCHER: 'バウチャー',
      QR_CODE_DISPLAY_LOCATION_ETICKET_PORTAL_SITE: 'Eチケット表示サイト'
    },
    voucherMedium: {
      ELECTRONIC: '印刷不要（画面提示）',
      PAPER: '印刷必須'
    },
    voucherVersion: {
      VOUCHER_VERSION_V1: 'V1',
      VOUCHER_VERSION_V2: 'V2'
    },
    formatType: {
      BEFORE_ACTIVITY_FORWARD_FIXED_CLOCK:
        '利用/参加日{D}日前の現地時間{HH:MM}以降のキャンセルは、予約総額の{N}のキャンセル料が発生いたします。',
      BEFORE_ACTIVITY_FORWARD_DURATION:
        '利用/参加日時の{T}時間前以降のキャンセルは、予約総額の{N}のキャンセル料が発生いたします。',
      AFTER_BOOKING_FORWARD_DURATION:
        '予約確定後の{T}時間以降、予約総額の{N}のキャンセル料が発生いたします。',
      AFTER_BOOKING_FORWARD_FIXED_CLOCK:
        '予約確定日を0日目として、{D}日目の現地時間{HH:MM}以降、予約総額の{N}のキャンセル料が発生いたします。',
      BEFORE_ACTIVITY_BACKWARD_FIXED_CLOCK:
        '利用/参加日の{D}日前の現地時間{HH:MM}まで、予約総額の{N}のキャンセル料が発生いたします。',
      BEFORE_ACTIVITY_BACKWARD_DURATION:
        '利用/参加日時の{T}時間前まで、予約総額の{N}のキャンセル料が発生いたします。',
      AFTER_BOOKING_BACKWARD_DURATION:
        '予約確定後の{T}時間前まで、予約総額の{N}のキャンセル料が発生いたします。',
      AFTER_BOOKING_BACKWARD_FIXED_CLOCK:
        '予約確定日を0日目として、{D}日目の現地時間{HH:MM}まで、予約総額の{N}のキャンセル料が発生いたします。'
    },
    cancellationFeeType: {
      PERCENTAGE: 'パーセンテージ',
      ADVANCED_PERCENTAGE: '高度なパーセンテージ設定',
      FIXED: '定額料金',
      NOT_CANCELLABLE: 'キャンセル不可'
    },
    basePrice: {
      GROSS: '販売価格',
      NET: '卸価格',
      SUPPLIER_NET: '催行会社卸価格'
    },
    confirmationType: {
      FREE_SALE: '参加日指定（フリーセル）',
      FREE_SALE_OPEN_DATE: '参加日指定不要（フリーセル）',
      INVENTORY: '参加日指定（即時確認）',
      REQUEST: '参加日指定（リクエスト）'
    },
    datePeriodUnit: {
      DAY: '日数計算',
      MONTH: '月数計算'
    },
    datePeriod: {
      DAY: '日間',
      MONTH: 'ヶ月間',
      tilde: '〜'
    },
    collectingType: {
      PER_PARTICIPANT: '参加者ごと',
      PER_BOOKING: '予約ごと'
    },
    collectingTiming: {
      ON_BOOKING: '予約時に必要',
      BEFORE_ACTIVITY: '参加日までに必要',
      OPTIONAL: '任意'
    },
    formType: {
      DATE_ONLY_PAST: '日付（過去のみ）',
      DATE_ONLY_FUTURE: '日付（未来のみ）',
      TIME: '時間',
      YES_NO: 'はい/いいえ',
      DROPDOWN: 'ドロップダウン選択',
      RADIO: 'ラジオボタン',
      CHECK: 'チェックボックス',
      TEXT: 'テキスト',
      TEXT_ALPHANUMERIC: 'テキスト（英数字）',
      TEXT_PHONE: '電話番号',
      TEXTAREA: 'テキストエリア'
    },
    voucherExpirationType: {
      FROM_PURCHASE_DATE: '購入日から',
      FROM_ACTIVITY_DATE: '参加日から',
      FIXED_DATE: '絶対固定日',
      RELATIVE_FIXED_DATE: '相対固定日'
    },
    unit: {
      AGE_ADULT_AND_CHILD: '大人・子供共通（{n}-{m}）歳',
      AGE_ADULT: '大人（{n}-{m}）歳',
      AGE_YOUTH: '中人（{n}-{m}）歳',
      AGE_CHILD: '子供（{n}-{m}）歳',
      AGE_SENIOR: 'シニア（{n}-{m}）歳',
      AGE_INFANT: '幼児（{n}-{m}）歳',
      AGE_STUDENT: '学生（{n}-{m}）歳',
      AGE_HIGH_SCHOOL: '高校生（{n}-{m}）歳',
      AGE_INTERMEDIATE_SCHOOL: '中学生（{n}-{m}）歳',
      AGE_ELEMENTALY_SCHOOL: '小学生（{n}-{m}）歳',
      AGE_COLLEGE: '大学生（{n}-{m}）歳',
      AGE_GRADUATE: '大学院生（{n}-{m}）歳',
      AGE_DISABLED_ADULT: '障がい者-大人（{n}-{m}）歳',
      AGE_DISABLED_YOUTH: '障がい者-中人（{n}-{m}）歳',
      AGE_DISABLED_CHILD: '障がい者-子供（{n}-{m}）歳',
      AGE_SUPPORTER_ADULT: '介護者（大人）',
      AGE_SUPPORTER_CHILD: '介護者（子供）',
      MINUTES_VEHICLES: '{n} 分間',
      HOURS_VEHICLES: '{n} 時間',
      DAYS_VEHICLES: '{n} 日間',
      WEEKS_VEHICLES: '{n} 週間',
      NIGHTS_VEHICLES: '{n} 泊',
      CHARTER_VAR: '1台（{n}-{m}）人',
      GROUP_VAR: '1グループ（{n}-{m}）人',
      ROOM_VAR: '1室（{n}-{m}）人',
      BOAT_VAR: '1艇（{n}-{m}）人',
      PET: 'ペット',
      PET_CAT: '猫',
      PET_DOG: '犬',
      PET_DOG_S: '小型犬',
      PET_DOG_M: '中型犬',
      PET_DOG_L: '大型犬',
      PET_DOG_XL: '超大型犬',
      PET_OTHER: 'その他ペット',
      AGE_ADULT_AND_CHILD_2: '一般',
      AGE_CHILD_2: '小人',
      DRINK_STANDARD_SET: 'スタンダードセット',
      DRINK_CHAMPAGNE_SET: 'シャンパンセット',
      QUANTITY: '1個'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '入金待ち',
      [InvoiceStatus.InvoiceStatusConfirmed]: '入金完了',
      [InvoiceStatus.InvoiceStatusPaid]: '入金確認中',
      [InvoiceStatus.InvoiceStatusCancelled]: 'キャンセル済'
    },
    activityTags: {
      NON_CANCELLABLE: 'キャンセル不可',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '引換前キャンセル無料',
      ADVANCE_CANCELLATION_POLICY: '特殊キャンセルポリシー',
      INSTANT_BOOK: '即予約',
      NON_QR_CODE: '目視バウチャー',
      QR_CODE: 'QRバウチャー',
      ETICKET: 'もぎりチケット（スマホ必要）'
    }
  },
  lang: {
    en: '英語',
    ja: '日本語',
    zh: '中国語（簡体）',
    zt: '中国語（繁体字）',
    ko: '韓国語'
  },
  component: {
    location: {
      title: '{{label}}名称',
      address: '住所',
      placeId: '場所 ID',
      latlong: '緯度経度',
      select: '{{label}}選択',
      errMsg:
        '検索対象が見つかりません。入力内容を再確認するか、またはマップから直接選択してください。'
    },
    checklist: {
      notice: '注意事項 {{index}}',
      selectNoticePrompt: '参加前・参加時の注意事項を選んでください',
      uploadPDF: 'PDFアップロード',
      uploadImage: '画像アップロード',
      googleMapSetting: 'Google Map設定'
    },
    cancel: {
      notCancellable: 'ご予約後のキャンセル・変更は受け付けておりません。',
      freeCancellable:
        '引換前まで無手数料で取消可。引換後、払戻は一切不可になります。',
      flex: '高度なキャンセルポリシーを設定する。',
      preview: 'プレビュー',
      cancelPreview: 'キャンセルポリシープレビュー',
      info: 'カスタム説明文',
      timeSetting: 'キャンセル日時設定',
      day: '日{D}',
      timeFormat: '時間{HH:MM}',
      time: '時間{T}',
      feeSetting: 'キャンセル料の設定',
      feeSettingPrompt: 'キャンセル料設定を選んでください',
      cancelPolicyPrompt: 'キャンセルポリシーを選択してください',
      priceReferenceSale: '価格基準：販売価格',
      priceReference: '価格基準：',
      fromClient: '旅行者から (%)',
      fromAgent: '旅行代理店から (%)',
      toSupplier: '催行会社に (%)',
      paymentCancelFee: 'キャンセル料のお支払い',
      fromClientToAgent: '旅行者から旅行代理店へ',
      fromAgentToLinktivity: '旅行代理店からLINKTIVITYへ',
      fromLinktivityToSupplier: 'LINKTIVITYから催行会社へ'
    },
    rule: {
      type: '予約タイプ',
      possibleInterval: '予約可能期間',
      interval: '予約受付締切日',
      daysBefore: '日前',
      timeBefore: '時まで'
    },
    faq: {
      question: '質問',
      answer: '回答',
      faqTitle: '項目 {{index}}'
    },
    voucher: {
      incrementDate: '年次増分基準日'
    },
    startTime: {
      id: 'ID',
      name: '開始時間',
      title: 'タイトル',
      poolId: '開始時間ID'
    },
    itinerary: {
      title: 'タイトル',
      detailedSchedule: 'スケジュール詳細'
    },
    additional: {
      id: '予約情報ID',
      title: '予約情報タイトル',
      info: '予約情報説明',
      setting: '予約情報設定方法',
      deadline: '回答締切',
      answerType: '回答形式',
      selectItems: '選択項目',
      selectPrompt: '選択してください'
    },
    price: {
      info: '価格 {{index}}',
      reservableInterval: '予約可能期間',
      startTime: '開始時間',
      endTime: '終了時間',
      unitType: 'ユニット種類',
      unitPrice: '販売単価',
      soldPrice: '販売価格',
      agentPrice: '卸価格',
      comission: 'コミッション',
      price: '料金',
      accuracy: '精度',
      rate: 'レート',
      comissionRate: 'コミッションレート（表示用）',
      comissionRateTips:
        '明細・帳票等にレートを表示する項目はこちらのレートが表示されます',
      auto: 'レート精度設定',
      applicableSetting: '適用期日設定',
      applicableInterval: '適用期間',
      applicableDates: '適用曜日',
      otherApplicableDates: 'その他適用日',
      unitRange: '単位範囲',
      standardPrice: '標準価格',
      numberIncluded: '定員に含む',
      soloPurchase: '単独購入'
    },
    backendForm: {
      cloudSchedulerJob: '同期ID',
      state: '状態',
      status: 'ステータス',
      lastExecution: '前回更新',
      nextExecution: '次回更新',
      selectSupplier: 'Supplier選択',
      name: '管理名',
      backendPoolId: 'Backend在庫管理ID',
      backend: 'Backend情報',
      selectBackendPlaceholder: '連携するBackendを選択してください',
      supplierPoolId: 'Supplier Pool ID',
      scheduleTimezone: '更新タイムゾーン',
      schedule: '更新スケジュール',
      scheduleNote: '※記載方法はこちらをご参考ください'
    },
    dateSetting: {
      titlePlaceholder: '在庫管理名を入力してください',
      name: '通常在庫設定',
      interval: '適用期間（曜日）',
      exactDates: '特定日',
      commonAllotment: '在庫設定',
      add: '通常在庫パターンを追加する',
      common: 'Common',
      freesale: 'フリーセール',
      createTitle: '在庫パターン設定',
      modal: {
        interval: '適用期間',
        dates: '適用曜日',
        otaAllotments: '旅行代理店在庫設定'
      }
    },
    editAllotment: {
      type: '種別',
      amountReserved: '予約数',
      amountEdited: '在庫数',
      amountRemains: '在庫残数',
      shared: '共有在庫'
    },
    calendar: {
      groupRule: '在庫表示',
      week: '週',
      month: '月',
      showMore: '詳しく',
      amountReserved: '実際の予約数',
      amountLimit: '最大予約数',
      edited: 'カレンダー編集で設定済み',
      notice: {
        title: 'このページで在庫数を直接変更する際はご注意ください。',
        orderLabel: '通常の設定順序：',
        orderValue: '【営業日・通常在庫設定】→【例外開始時間設定】',
        tempLabel: '一時調整・緊急クローズ：',
        tempValue: '【カレンダー編集】から直接変更できます。',
        priorityLabel: '優先度ルール：',
        priorityValue:
          '【カレンダー編集】（最優先）→【例外開始時間設定】（中）→【営業日・通常在庫設定】（基本）',
        remark:
          '※【カレンダー編集】で在庫を設定すると、その時間帯の通常設定・例外設定は自動的に無効となり、【カレンダー編集】の数値が適用されます。'
      }
    },
    segmentId: {
      name: '開始時間ID',
      addPrompt: '開始時間ID追加',
      refTime: '参考時間',
      startTimeIdRequired: '開始時間IDを入力してください',
      startTimeRequired: '開始時間を入力してください'
    }
  }
};
